import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i class="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">3 years working</span>
      </div>

      <div className="about__box">
        <i class="bx bxs-plane-alt about__icon"></i>
        <h3 className="about__title">Relocation</h3>
        <span className="about__subtitle">Open to moving</span>
      </div>

      <div className="about__box">
        <i class="bx bx-bulb about__icon"></i>
        <h3 className="about__title">Learner</h3>
        <span className="about__subtitle">Always curious</span>
      </div>
    </div>
  );
};

export default Info;
